import { ApiClient } from "./api";

const client = new ApiClient();

export class Tracker {
  private static _instance: Tracker;

  public static get Instance() {
    return this._instance || (this._instance = new this());
  }

  private hasSentSessionStart = false;

  public loggedIn = async (userId: string, username: string, name: string) => {
    // signal session start to our backend
    if (this.hasSentSessionStart) return;
    try {
      await client.sendSessionStart();
      this.hasSentSessionStart = true;
    } catch (error) {
      console.log("failed to signal session start with error: ");
      console.error(error);
    }

    // track in hotjar
    if (!!(window as any).hj)
      (window as any).hj("tagRecording", [username, name, userId]);
  };
}
